import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { api } from "@/lib/api";
import { Snowflake, Lock } from "@phosphor-icons/react";

const CATEGORY_COLORS = {
  Sleep: "border-[#5AC8FA] text-[#5AC8FA]",
  Hydration: "border-[#34C759] text-[#34C759]",
  "Cold Therapy": "border-[#5AC8FA] text-[#5AC8FA]",
  Mobility: "border-[#FF9F0A] text-[#FF9F0A]",
  Nutrition: "border-[#FF3B30] text-[#FF3B30]",
  "Soft Tissue": "border-[#FF9F0A] text-[#FF9F0A]",
  "Mental Recovery": "border-[#BF5AF2] text-[#BF5AF2]",
};

export default function Recovery() {
  const [tips, setTips] = useState([]);
  const [lockedCount, setLockedCount] = useState(0);

  useEffect(() => {
    api.get("/recovery/tips").then((r) => { setTips(r.data.tips); setLockedCount(r.data.locked_count); });
  }, []);

  return (
    <Layout>
      <div className="p-8 md:p-12">
        <div className="mb-10">
          <div className="text-xs font-heading uppercase tracking-widest text-[#FF3B30]">/ Recovery Ops</div>
          <h1 className="font-heading font-black uppercase text-5xl mt-2 flex items-center gap-4">
            <Snowflake size={48} weight="duotone" className="text-[#FF3B30]" /> Recovery Tips
          </h1>
        </div>

        <div className="grid md:grid-cols-2 gap-4">
          {tips.map((t) => (
            <div key={t.id} className="border border-[#262626] bg-[#121212] p-6" data-testid={`tip-${t.id}`}>
              <div className={`inline-block border px-2 py-0.5 text-xs font-heading uppercase tracking-widest mb-3 ${CATEGORY_COLORS[t.category] || "border-[#FF3B30] text-[#FF3B30]"}`}>
                {t.category}
              </div>
              <h3 className="font-heading font-bold uppercase text-xl mb-2">{t.title}</h3>
              <p className="text-sm text-[#A3A3A3] leading-relaxed">{t.content}</p>
            </div>
          ))}
        </div>

        {lockedCount > 0 && (
          <div className="mt-6 border-2 border-dashed border-[#262626] p-10 text-center" data-testid="locked-tips">
            <Lock size={36} className="text-[#A3A3A3] mx-auto mb-3" />
            <div className="font-heading uppercase tracking-widest text-lg">{lockedCount} more protocols locked</div>
            <div className="text-sm text-[#A3A3A3] mt-2 mb-6">Ice bath timing, mobility routines, and elite recovery science.</div>
            <Link to="/pricing" className="inline-block border border-[#FF3B30] bg-[#FF3B30] text-white px-8 py-3 font-heading uppercase tracking-widest text-sm">Upgrade</Link>
          </div>
        )}
      </div>
    </Layout>
  );
}
